export enum UserRole {
  Admin = 1,
  User = 2,
  Affiliate = 3,
}
